import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularIndicator from '../common/indicators/circularIndicator';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
//import TagsDisplay from '../driver/tagsDisplay';

const RankingTable = props => (
  <section className="new-ranking-table">
    <div className="table-content">
      <table>
        <thead>
          <tr className="tr-header">
            <th className="new-ranking-table-th new-ranking-th left-th">
              <div className="th-flex">
                <div id="pd-right">
                  <span>&#8470;</span>
                  <span>{props.language.detail_waiting_times.detailTruck.ranking}</span>
                </div>

                <div>
                  <div>
                    <i className="fas fa-sort-up up" />
                  </div>
                  <div>
                    <i className="fas fa-sort-down down" />
                  </div>
                </div>
              </div>
            </th>
            <th className="new-ranking-table-th new-team-th left-th">
              {props.rankingLabel === 'vehicle' ? 'Equipo' : 'Conductor'}
            </th>
            <th className="new-ranking-table-th newvalue-th" />
            <th className="new-ranking-table-th newvalue-th nota">
              <div className="th-flex-1">
                <div className="nota-with">
                  {props.language.detail_waiting_times.detailTruck.averageNote}
                </div>
                <div>
                  <div>
                    <i className="fas fa-sort-up up" />
                  </div>
                  <div>
                    <i className="fas fa-sort-down down" />
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.data
            ? props.data.map((data, i) => {
                return (
                  <tr data-driverid="id" key={`t-ranking-table-${i}`}>
                    <td className="new-ranking-td">{data.ranking}</td>
                    <td className="new-info-td">
                      <span>{data.alias}</span>
                    </td>
                    <td className="td_inspection">
                      <div>
                        <span>{props.language.detail_waiting_times.detailTruck.inspections}:</span>
                        <span>{data.inspections}</span>
                      </div>
                      <div>
                        <span>{props.language.detail_waiting_times.detailTruck.fails}:</span>
                        <span>{data.fails}</span>
                      </div>
                    </td>
                    <td className="td-pie">
                      <div className="new-circular-wraper">
                        <span className="circular-table-value">
                          {data.averageScore.actual.value ? data.averageScore.actual.value : ''}
                        </span>
                        <CircularProgress
                          className={'circular-green'}
                          variant="static"
                          size={props.size}
                          // max={props.max}
                          value={data.averageScore.actual.value}
                          //graphColorRange={props.graphColorRange}
                          // valueFormat={{
                          //   type: 'NUMBER',
                          //   format: props.kpiFormat ? props.kpiFormat : '.0f'
                          // }}
                          thickness={3}
                        />
                      </div>

                      {data.averageScore.trend === 'Better' ? (
                        <div className="toolltip">
                          <i className="fas fa-arrow-up arrow" />
                          <div className="bottom">
                            <h3 className="green">{`${
                              data.averageScore.differenceValue
                            } puntos mas con respeto al periodo anterior`}</h3>
                            <div className="pd-bottom">
                              <span>{props.language.detail_waiting_times.detailTruck.befor}</span>
                              <span>{` (${moment(
                                data.averageScore.previous.start.substring(0, 10)
                              ).format('DD/MM')} al ${moment(
                                data.averageScore.previous.end.substring(0, 10)
                              ).format('DD/MM')}) `}</span>
                              <span className="green">{data.averageScore.previous.value}</span>
                            </div>
                            <div>
                              <span>{props.language.detail_waiting_times.detailTruck.now}</span>
                              <span>{` (${moment(
                                data.averageScore.actual.start.substring(0, 10)
                              ).format('DD/MM')} ${
                                props.language.detail_waiting_times.detailTruck.to
                              } ${moment(data.averageScore.actual.end.substring(0, 10)).format(
                                'DD/MM'
                              )}) `}</span>
                              <span className="green">{data.averageScore.actual.value}</span>
                            </div>
                            <i />
                          </div>
                        </div>
                      ) : data.averageScore.trend === 'Worse' ? (
                        <div className="toolltip btn btn-primary">
                          <i className="fas fa-arrow-down arrow fa-2x" />
                          <div className="bottom">
                            <h3 className="red">{`${
                              data.averageScore.differenceValue
                            } punto menos con respetos al periodo anterior`}</h3>
                            <div className="pd-bottom">
                              <span>{props.language.detail_waiting_times.detailTruck.befor}</span>
                              <span>{` (${moment(
                                data.averageScore.previous.start.substring(0, 10)
                              ).format('DD/MM')} al ${moment(
                                data.averageScore.previous.end.substring(0, 10)
                              ).format('DD/MM')}) `}</span>
                              <span className="green">{data.averageScore.previous.value}</span>
                            </div>
                            <div>
                              <span>{props.language.detail_waiting_times.detailTruck.now}</span>
                              <span>{` (${moment(
                                data.averageScore.actual.start.substring(0, 10)
                              ).format('DD/MM')} al ${moment(
                                data.averageScore.actual.end.substring(0, 10)
                              ).format('DD/MM')}) `}</span>
                              <span className="green">{data.averageScore.actual.value}</span>
                            </div>
                            <i />
                          </div>
                        </div>
                      ) : data.averageScore.trend === 'Same' ? (
                        ''
                      ) : (
                        <span className="arrow" />
                      )}
                      {data.averageScore.trend ? (
                        data.averageScore.trend === 'Same' ? (
                          <span className="arrow arrow-value" />
                        ) : (
                          <span className="arrow arrow-value">
                            {data.averageScore.differenceValue}
                          </span>
                        )
                      ) : (
                        <span className="arrow arrow-value" />
                      )}
                    </td>
                  </tr>
                );
              })
            : ''}
        </tbody>
      </table>
    </div>
  </section>
);

export default RankingTable;



// WEBPACK FOOTER //
// ./source/client/components/detail_truck/rankingTable.jsx